import React from 'react';

const PlayIcon = () => {
  return (
    <svg
      style={{ padding: '20%' }}
      viewBox="10 10 40 40"
      xmlns="http://www.w3.org/2000/svg"
      role="graphics-symbol"
      aria-label="play"
    >
      <path d="M15 10L50 30L15 50L15 10Z" />
    </svg>
  );
};

export default PlayIcon;
